import React, { useEffect } from 'react';
import { TruckIcon } from '@heroicons/react/24/outline';

const TrackingPage: React.FC = () => {
  useEffect(() => {
    // Redirect to autosrealm.com after a short delay
    const timer = setTimeout(() => {
      window.location.href = 'https://autosrealm.com/';
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-primary-100 rounded-full p-4">
              <TruckIcon className="w-16 h-16 text-primary-600 animate-bounce" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Vehicle Tracking & Shipping
          </h1>
          
          <p className="text-gray-600 mb-6">
            Redirecting you to our shipping and tracking partner...
          </p>

          <div className="flex justify-center mb-6">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 text-left">
            <p className="text-sm text-blue-800">
              <strong>Shipping Services:</strong>
            </p>
            <ul className="text-sm text-blue-700 mt-2 space-y-1">
              <li>• Track your vehicle shipment</li>
              <li>• Get shipping quotes</li>
              <li>• Arrange vehicle transport</li>
              <li>• International shipping available</li>
            </ul>
          </div>

          <p className="text-xs text-gray-500 mt-6">
            If you're not redirected automatically, 
            <a 
              href="https://autosrealm.com/" 
              className="text-primary-600 hover:text-primary-700 font-medium ml-1"
            >
              click here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrackingPage;

